import React from 'react';
import DocumentTitle from 'react-document-title';
import './signup2.css'

export default class SignUpPage2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            firstLine:"",
            secondLine:"",
            city:"",
            province:"",
            vat:"",

        }
this.handValueChange=this.handValueChange.bind(this)
    }

    handValueChange(component,value){
        let self=this;
        this.setState({
            [component]:value
        },function () {
            let address=self.state.firstLine+"\n"+self.state.secondLine+"\n"+self.state.city+"\n"+self.state.province
            let vat=self.state.vat
            self.props.changer().handleChangeData("location",address)
            self.props.changer().handleChangeData("vat",vat)
        })
    }
    getData() {
        return this.state
    }
    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <div className="signupcontainer">

                    <div className="imagecontainer">

                        <img src="https://client.khula.co.za/images/farmers.JPG" alt="" width="100%" height="auto"/>

                    </div>

                    <div className="signupcontent">

                        <h2>Register your profile</h2>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/farmer_signup.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Address (Line 1)" onChange={(e)=>this.handValueChange("firstLine",e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/id-card.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Address (Line 2)" onChange={(e)=>this.handValueChange("secondLine",e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/id-card.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="City" onChange={(e)=>this.handValueChange("city",e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/factory.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="Province" onChange={(e)=>this.handValueChange("province",e.target.value)}/>
                        </div>

                        <div className="input-container">
                            <div className="icon">
                                <img src="https://client.khula.co.za/images/gmail.png" alt=""/>
                            </div>
                            <input className="input-field" type="text" placeholder="VAT number" onChange={(e)=>this.handValueChange("vat",e.target.value)}/>
                        </div>

                        {/*<div className="input-container">*/}
                            {/*<div className="icon">*/}
                                {/*<img src="https://client.khula.co.za/images/padlock.png" alt=""/>*/}
                            {/*</div>*/}
                            {/*<input className="input-field" type="text" placeholder="Users" name="usrnm"/>*/}
                        {/*</div>*/}


                    </div>

                    {/*<div className="button">*/}
                        {/*<button className="signupbutton" type="button" name="button">Next</button>*/}
                    {/*</div>*/}

                </div>
            </DocumentTitle>

        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/SignUpPages/Page2.js